export const environment = {
  production: false,
  api_url: 'https://bubba.wibodev.com',
  api_admin_url: 'https://bubba-admin.wibodev.com',
  auth_token_key: 'auth-totem',
  site_id: '', //Este campo debe ser generado cada vez que se cree una pwa
  version: '0.0.1',
  support: {
    type: 'chat',
    url: 'https://ayuda.holadary.com/'
  }
};
